import { IdentificationModal } from '@fiverr-private/identification_business';

export default IdentificationModal;
